import Base from "../Base";

export class LastMessage extends Base{
    isSeen;
    id;
    type;
    roomID;
    userID;
    message;
    createdAt;

    dates = ['createdAt'];
    integers = ['userID'];

    constructor(data) {
        super();
        this.setUp(this, data);
    }
}